"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Counter = _interopRequireDefault(require("./Counter.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Counter = _ref => {
  let {
    itemsCounter = 0,
    lang,
    loading
  } = _ref;
  const css = (0, _Counter.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.counter, "mco-shop-product-overview-counter")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.label
  }, loading ? /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.labels.loading",
    l: l
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "".concat(itemsCounter, " ").concat(itemsCounter === 1 ? l("reactShop.productOverview.counter.labels.product") : l("reactShop.productOverview.counter.labels.products")))));
};
var _default = exports.default = Counter;